import { Pipe, PipeTransform, inject } from '@angular/core';
import { environment } from '@env';
import { AwareAuthService } from '@appbolaget/aware-auth';
import { Store } from '@ngxs/store';
import { UnitState } from 'app/state/unit.state';
import { AppState } from 'app/state/app.state';

@Pipe({
    name: 'secureImg',
    standalone: true,
})
export class SecureImagePipe implements PipeTransform {
    private awareAuth = inject(AwareAuthService);
    private store = inject(Store);
    constructor() {}

    transform(url: string, unit?: string, includeBase = true, includeToken = true) {
        unit = unit ? unit : this.store.selectSnapshot(UnitState.activeUnit).uuid;
        const token = this.awareAuth.currentState.identityToken;
        let unitAndTokenParams = `unit=${unit}`;

        if (includeToken) {
            unitAndTokenParams = `${unitAndTokenParams}&token=${token}`;
        }

        if (url.includes('?')) {
            url = `${url}&${unitAndTokenParams}`;
        } else {
            url = `${url}?${unitAndTokenParams}`;
        }

        const apiEnv = this.store.selectSnapshot(AppState.apiEnv);
        const baseUrl = apiEnv?.url || environment.api.url;

        url = url.startsWith(baseUrl) || !includeBase ? url : `${baseUrl}/@media/${url}`;

        return url;
    }
}
